export default {
  saveSuccessMsg: '保存成功！',
  changeLanguageTips: '切換語言成功',
  modifyPwdSuccess: '密碼修改成功！',
  noFileMsgOrError: '沒有文件信息或文件報錯',
  immutableInfo: '該學生信息不可修改！',
  unknownError: '未知錯誤，請聯系管理員！',
  expired: '認證已過期',
  deleteSuccess: '刪除成功',
  addSuccess: '新增成功',
  editSuccess: '編輯成功',
  setSuccess: '設置成功',
  removeSuccess: '移除成功',
  removeSuperiorConfirm: '您確定要為{name}移除所勾選的業務上司嗎？',
  appendSuperiorConfirm: '您確定要將勾選的人設置為{name}的業務上司嗎？',
  uploadLimit: "上傳文件只能是PDF格式",
  uploadSize: "上傳文件不能超過{limit}M",
  uploadFail: "上傳失敗",
  delMsgFile: "您確定定要刪除該文件吗？",
  deleteSucc: "刪除成功",
  deleteFail: "刪除失敗",
  differentialSubmissionConfirm: "您確定要差異提交當前賬單嗎？",
  differentialSubmissionConfirm2: '請先勾選您要差異提交的當前賬單選項！',
  differentialSubmissionSuccess: "差異提交成功",
  pleaseSelectAllUnsettledPayBackStatement: '請先勾選所有負賬單再點擊提交！',
  unsettledPayBackStatementMessage:'負賬單差異提交審核中，無法提交結算！',
  pleaseSelectBankInfo: '請選擇銀行信息！',
  pleaseSelectSettleMethod: '請選擇結算方式！',
  pleaseCompleteSettleInfo: '請完善結算幣種信息！',
  pleaseCompleteOriginalCurrency: '請完善原幣種信息！',
  uploadFileTips: '僅支持PDF格式文件，請重新上傳符合格式要求的文件！',
  submitAndDownloadSuccess: '提交並下載成功！',
  downloadSuccess: '下載成功！',
  pleaseSelectSettledMessage: '請先勾選您需要結算的佣金！',
  businessOverviewMessage: '請先選擇年份！',
  selectInstitutionMessage: ' 院校名稱和申請國家/地區是聯動的，請選擇申請國家/地區',
}
